import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { createVideoCategory, deleteVideoCategory, getVideoCategories, updateVideoCategory } from "src/api/videos";

export const useVideoCategories = () => {
	const queryClient = useQueryClient();

	const {
		data: categories = [],
		isLoading,
		error,
	} = useQuery({
		queryKey: ["videoCategories"],
		queryFn: getVideoCategories,
	});

	const createMutation = useMutation({
		mutationFn: (name: string) => createVideoCategory(name),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["videoCategories"] });
		},
	});

	const updateMutation = useMutation({
		mutationFn: ({ categoryId, name }: { categoryId: number; name: string }) => updateVideoCategory(categoryId, name),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["videoCategories"] });
		},
	});

	const deleteMutation = useMutation({
		mutationFn: (categoryId: number) => deleteVideoCategory(categoryId),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["videoCategories"] });
		},
	});

	const deleteCategoryAsync = (categoryId: number) => deleteMutation.mutateAsync(categoryId);

	return {
		categories,
		isLoading,
		error,
		createCategory: createMutation.mutate,
		updateCategory: updateMutation.mutate,
		deleteCategory: deleteMutation.mutate,
		deleteCategoryAsync,
		isCreating: createMutation.isPending,
		isUpdating: updateMutation.isPending,
		isDeleting: deleteMutation.isPending,
	};
};
